import { useSelector } from 'react-redux'

import {
  selectAvailableUnits,
  selectAvailableUnitsFetched
} from 'redux/selectors/AvailableUnits'

export const useAvailableUnits = () => {
  return useSelector(selectAvailableUnits)
}

export const useAvailableUnitsFetched = () => {
  return useSelector(selectAvailableUnitsFetched)
}
